import React from 'react'
import { ApplicationModel } from '@/models/application.model'

interface Props {
  items: ApplicationModel[]
  onView: (app: ApplicationModel) => void
  programmeNameById?: Record<string, string>
}

export const ApplicationsTable: React.FC<Props> = ({ items, onView, programmeNameById }) => {
  if (!items.length) {
    return (
      <div className="border rounded-xl p-10 text-center bg-white">
        <p className="text-gray-600">No applications found.</p>
      </div>
    )
  }

  return (
    <div className="w-full max-w-full overflow-hidden bg-white border rounded-2xl shadow-sm">
      <div className="w-full overflow-x-auto">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gray-50 text-gray-700 border-b">
            <tr>
              <th className="px-6 py-4 font-medium">Applicant Name</th>
              <th className="px-6 py-4 font-medium">Email / Phone</th>
              <th className="px-6 py-4 font-medium">Programme</th>
              <th className="px-6 py-4 font-medium">JAMB Score</th>
              <th className="px-6 py-4 font-medium">Status</th>
              <th className="px-6 py-4 font-medium">Payment</th>
              <th className="px-6 py-4 font-medium text-right">Submitted</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {items.map((app) => (
              <tr key={app.id ?? app.app_id} className="hover:bg-gray-50 transition">
                <td className="px-6 py-4">
                  <a href="#" onClick={() => onView(app)} className="text-gray-600 underline hover:text-gray-900">
                    <p className="font-medium text-gray-900">
                      {app.first_name} {app.last_name}
                    </p>
                  </a>
                </td>
                <td className="px-6 py-4 text-gray-600">
                  <p>{app.email ?? '—'}</p>
                  <p className="text-xs text-gray-500">{app.phone ?? '—'}</p>
                </td>
                <td className="px-6 py-4 text-gray-700">
                  {app.programme_id
                    ? programmeNameById?.[app.programme_id] ?? app.programme_id
                    : '—'}
                </td>
                <td className="px-6 py-4 font-medium">{app.jamb_score ?? '—'}</td>
                <td className="px-6 py-4">
                  <span
                    className="flex items-center justify-center text-center text-xs font-medium px-2 py-1 rounded-full border"
                    style={{ borderColor: '#7b2a40', color: '#7b2a40' }}
                  >
                    {app.status ?? '—'}
                  </span>
                </td>
                <td className="px-6 py-4">
                  <div className="text-xs capitalize text-gray-700">{app.payment_status ?? '—'}</div>
                  <div className="mt-1 h-2 w-24 rounded-full bg-gray-100">
                    <div
                      className="h-full rounded-full bg-[#7b2a40]"
                      style={{ width: `${app.paymentPercentComplete ?? 0}%` }}
                      aria-label={`Payment ${app.paymentPercentComplete ?? 0}%`}
                    />
                  </div>
                </td>
                <td className="px-6 py-4 text-right text-gray-500">
                  {app.submitted_at
                    ? new Date(app.submitted_at).toLocaleDateString()
                    : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
